import { Box, Grid } from "@mui/material"
import AppDialog from "../../../components/Common/AppDialog"
import Label from "../../../components/Common/Label"
import Helpers from "../../../helpers/helpers"
import ImportantNotice from "../../../components/Common/ImportantNotice"
import { useState } from "react"

export default function AccessoriesPublish({ open, close, handleSubmit, windowWidth, isBulkAction = false, selectedItems = [] }) {
    const [showAll, setShowAll] = useState(false);
    const itemsToShow = isBulkAction ? showAll ? selectedItems : selectedItems.slice(0, 2) : [];
    return (
        <AppDialog
            title={`Publish ${isBulkAction ? 'Selected' : ''} Accessor${isBulkAction ? 'ies' : 'y'}`}
            open={open}
            close={close}
            positiveTitle={'Publish'}
            positivePress={() => handleSubmit()}
            cancelButton={true}
            width={'50%'}
            isMobile={windowWidth <= 768}
        >
            {
                isBulkAction ?
                    <>
                        <div>Are you sure you want to publish {selectedItems.length} selected accessories?</div>
                        <ol style={{ paddingInline: 20, paddingBlock: 10 }}>
                            {itemsToShow?.map((item, idx) => (
                                <li key={idx} className="mb-2 ">
                                    <div className="d-flex align-items-center">
                                        {item?.name || '-'}
                                        <Label.GeneralStatusLabel label={item?.status || '-'} list={Helpers.accessoryStatus} marginLeft={"10px"} />
                                    </div>
                                </li>
                            ))}
                            {selectedItems.length > 2 && (
                                <div
                                    onClick={() => setShowAll(!showAll)}
                                    className="clickable underline"
                                    style={{ marginTop: '10px' }}
                                >
                                    {showAll ? 'Show less' : 'Show more'}
                                </div>
                            )}
                        </ol>
                    </>
                    :
                    <>
                        <div>Are you sure you want to publish this accessory?</div>
                    </>
            }
            <div className="my-2">
                <ImportantNotice
                    iconName={'solar:lightbulb-linear'}
                    iconColor={'#1D1B1B'}
                    backgroundColor={'#F0F0F0'}
                    color={'#1D1B1B'}
                    message={'Once published, these accessories will become visible on the marketplace and available to buyers.'}
                />
            </div>
        </AppDialog>
    )
}